import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js"; // Function to fetch user data
import { getOrgById, getOrgByRef } from "../../models/OrgFunctions.js"; // Functions to fetch org and client data

import {
  getDateFromFlutter,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getRefFromId,
  queryCollection,
} from "../../models/DataFunctions.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import TextField2 from "../../textfields/TextField2.js";
import deleteDocApi from "../../api/database/deleteDocApi.js";
import { useAppContext } from "../../config/AppContext.js";

import { useSnackbar } from "notistack";

import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";

import WarningButton from "../../buttons/WarningButton.js";
import { Spin } from "antd";
import { ToggleSettingsBrick } from "../../textfields/EasySwitch.js";
import { check } from "prettier";
import TextField2T from "../../textfields/TextField2T.js";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import updateDocApi from "../../api/database/updateDocApi.js";
import getFactureHexagoneUrls from "../../api/presigned/getFactureHexagoneUrls.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
function ActionAdmin({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);
  const [pushOpen, setPushOpen] = useState(false);
  const [title = "", setTitle] = useState("");
  const [body = "", setBody] = useState("");

  const [selected_ticket, setSelectedTicket] = useState(null);
  const [count, setCount] = useState(1000);
  const [logs, setLogs] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [emailOpen, setEmailOpen] = useState(false);
  // Function to navigate to a client by ID
  const gotoUser = async (log) => {
    const obj = await getDocDataByRef(log.ref);
    setSelectedTicket(obj);
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [factures_hexagone, setFacturesHexagone] = useState([]);

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserById(currentUser.uid);
      const maintenance = await getDocDataById("maintenance", "maintenance");
      setMaintenance(maintenance);
      const banner = await getDocDataById(
        "maintenance",
        "feXLghrFEHIXxEroBrSl"
      );
      setBanner(banner);

      // Fetch organization data using the user's org reference
      const org = await getOrgById(user.org_id);
      let tickets = [];
      let filters = [];

      filters = [];
      // Fetch clients associated with the user's organization
      tickets = await queryCollection(
        "support_request",
        filters,
        500,
        "date",
        "desc"
      );

      const facture_filters = [];
      let factures_hexagone = await queryCollection(
        "facture_hexagone",
        facture_filters
      );

      setFacturesHexagone(factures_hexagone);

      // Transform clients into table format (rows and columns)

      // Update state if the user data is new or changed

      setUserData(user);
      setOrgData(org);
      handleGraphActivity();

      // Set options for the search bar (client names)
      setOptions(tickets.map((log) => log.email));
    }
  };

  const [loadingOpenFacture, setLoadingOpenFacture] = useState(false);
  const handleOpenFacture = async (facture) => {
    setLoadingOpenFacture(true);
    const token = await getOrRefreshFirebaseToken();
    await getFactureHexagoneUrls(facture.id, token, prefix);
    let new_facture = await getDocDataByRef(facture.ref);
    window.open(new_facture.file.url, "_blank");
    handleClickVariant("Ouverture de la facture", "success");
    setLoadingOpenFacture(false);
  };
  const [loadingActivity, setLoadingActivity] = useState(false);
  const handleGraphActivity = async () => {
    setLoadingActivity(true);

    setLoadingActivity(false);
  };

  const handleDisconnectAllPennylaneUsers = async () => {
    // loop through each master org and set pennylane.connected to false
    let org_filters = [
      {
        field: "type",
        operator: "==",
        value: "master",
      },
    ];
    let master_idrgs = await queryCollection("org", org_filters);
    for (let org of master_idrgs) {
      await updateDocDataFieldApi(
        org.ref,
        "pennylane.connected",
        false,
        prefix
      );
    }
    handleClickVariant(
      "All Pennylane connections disconnected " +
        master_idrgs.lenght +
        " orgs affected",
      "success"
    );
  };

  const handleSaveMaintenance = async () => {
    let reff = getRefFromId("maintenance", "maintenance");
    await updateDocApi(
      reff,
      {
        active: maintenace?.active || false,
        message: maintenace?.message || "",
      },
      prefix
    );
    await updateDocApi(
      getRefFromId("maintenance", "feXLghrFEHIXxEroBrSl"),
      {
        message: banner?.message || "",
      },
      prefix
    );

    handleClickVariant(
      "Maintenance set to " +
        (maintenace?.active ? "active" : "inactive") +
        " with message: " +
        (maintenace?.message || ""),
      "success"
    );
    handleFetchData();
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  const [confirm, setConfirm] = useState(null);
  const [maintenace, setMaintenance] = useState(null);
  const [banner, setBanner] = useState(null);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  // Render the client data
  return (
    <div className="flex flex-col h-screen w-full p-4">
      {" "}
      <div className=" flex flex-row w-full h-full">
        <div className="flex flex-col h-full  gap-2 w-c4+00">
          <div className="text-hx font-medium flex flex-row gap-4 max-w-c400">
            <div>Actions administrateurs</div>
          </div>
          <TextField2
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            label="CONFIRMER"
            className="max-w-c300"
          ></TextField2>
          <WarningButton
            disabled={confirm !== "CONFIRMER"}
            onClick={handleDisconnectAllPennylaneUsers}
            className={"w-fit"}
          >
            Disconnect Pennylane connexion for all users
          </WarningButton>
          <SecondaryButton
            className={"w-fit"}
            onClick={() => handleClickVariant("Error", "error")}
          >
            Trigger Error
          </SecondaryButton>
          <SecondaryButton
            className={"w-fit"}
            onClick={() => handleClickVariant("Success", "success")}
          >
            Trigger Success
          </SecondaryButton>
          <ToggleSettingsBrick
            checked={maintenace?.active}
            onChange={(checked) => {
              setMaintenance({ ...maintenace, active: checked });
            }}
            title={"Maintenance mode"}
            description={
              "When active, the app will be in maintenance mode and users will not be able to access it."
            }
          ></ToggleSettingsBrick>
          <TextField2T
            value={maintenace?.message || ""}
            onChange={(e) => {
              setMaintenance({ ...maintenace, message: e.target.value });
            }}
            label={"Maintenance message (will be displayed to users)"}
          ></TextField2T>
          <TextField2T
            value={banner?.message || ""}
            onChange={(e) => {
              setBanner({ ...banner, message: e.target.value });
            }}
            label={"Banner message (will be displayed to users)"}
          ></TextField2T>
          <PrimaryButton className={"w-fit"} onClick={handleSaveMaintenance}>
            Enregistrer
          </PrimaryButton>
          {/* DataGrid displaying the clients */}

          {loadingActivity && <SmallSpinner></SmallSpinner>}
          {factures_hexagone.map((facture) => (
            <div
              key={facture.id}
              className="flex flex-row gap-2 items-center justify-between border-t-1 border-shadow_5 py-1"
            >
              <div className="text-h3 text-shadow_50 font-semibold">
                {facture.type === "fees"
                  ? "Frais"
                  : facture.type === "subscription"
                    ? "Abonnement"
                    : "Achat de jetons"}
              </div>
              <div className="text-h3 text-shadow_50">{facture.name}</div>
              <div className="text-h3 text-shadow_50">
                {getDateFromFlutter(facture.date).toLocaleString()}
              </div>
              {facture.amount}
              <SecondaryButton
                onClick={() => handleOpenFacture(facture)}
                className="w-fit"
                disabled={loadingOpenFacture}
              >
                Ouvrir
                <SmallSpinner loading={loadingOpenFacture} />
              </SecondaryButton>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ActionAdmin;
